module.exports = __webpack_public_path__ + "static/media/22713566_1629549987120186_3788921165687032455_o.703e1283.jpg";